import { api } from '@/lib/axios';

export interface WhatsAppConnection {
  id: string;
  name: string;
  instanceName: string;
  status: 'DISCONNECTED' | 'CONNECTING' | 'OPEN' | 'CLOSE';
  phoneNumber?: string;
  profileName?: string;
  profilePicUrl?: string;
  isDefault: boolean;
  createdAt: string;
}

export interface CreateConnectionDto {
  name: string;
  instanceName: string;
  apiUrl?: string;
  apiKey?: string;
  isDefault?: boolean;
}

export interface ConnectResponse {
  qrcode?: string;
  pairingCode?: string;
  status: string;
}

export const whatsappConnectionsService = {
  /**
   * Lista todas as conexões
   */
  async getAll(): Promise<WhatsAppConnection[]> {
    const response = await api.get('/whatsapp/connections');
    return response.data;
  },

  /**
   * Busca uma conexão específica
   */
  async getOne(id: string): Promise<WhatsAppConnection> {
    const response = await api.get(`/whatsapp/connections/${id}`);
    return response.data;
  },

  /**
   * Cria uma nova conexão
   */
  async create(data: CreateConnectionDto): Promise<WhatsAppConnection> {
    const response = await api.post('/whatsapp/connections', data);
    return response.data;
  },

  /**
   * Atualiza uma conexão
   */
  async update(id: string, data: Partial<CreateConnectionDto>): Promise<WhatsAppConnection> {
    const response = await api.put(`/whatsapp/connections/${id}`, data);
    return response.data;
  },

  /**
   * Remove uma conexão
   */
  async delete(id: string): Promise<void> {
    await api.delete(`/whatsapp/connections/${id}`);
  },

  /**
   * Verifica status da conexão
   */
  async checkStatus(id: string): Promise<WhatsAppConnection & { evolutionState: string }> {
    const response = await api.get(`/whatsapp/connections/${id}/status`);
    return response.data;
  },

  /**
   * Conecta (gera QR Code)
   */
  async connect(id: string): Promise<ConnectResponse> {
    const response = await api.post(`/whatsapp/connections/${id}/connect`);
    return response.data;
  },

  /**
   * Desconecta
   */
  async logout(id: string): Promise<void> {
    await api.post(`/whatsapp/connections/${id}/logout`);
  },
};
